
import Api from "./Api";

class postsService {
    getAll = (params = {}, data = {}) => Api.post(`/api/posts/get`, params, data);
}
export default new postsService();